module.exports = __webpack_public_path__ + "static/011-e02c5895cddb26c7d120e8eb2761fd90.jpg";